import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import BarraProgresso from '../components/BarraProgresso';
import { useAuth } from '../contexts/AuthContext';
import api from '../api';

const DOC_ICONE = {
  pop: 'bi-card-checklist', manual: 'bi-journal-text', descricao_cargo: 'bi-person-badge',
  informativo: 'bi-info-circle', treinamento_video: 'bi-play-btn-fill', cultura: 'bi-heart', ata: 'bi-file-earmark-text',
};

function Item({ item, trilhaId }) {
  const ehDoc = item.tipo === 'documento';
  const icone = ehDoc ? (DOC_ICONE[item.doc_tipo] || 'bi-file-earmark-text') : 'bi-patch-question-fill';
  const destino = ehDoc
    ? `/documentos/${item.documento_id}?trilha=${trilhaId}&item=${item.id}`
    : `/academia/quiz/${item.quiz_id}?trilha=${trilhaId}&item=${item.id}`;

  const corpo = (
    <>
      <div className="trilha-item-icone"><i className={`bi ${icone}`}></i></div>
      <div className="trilha-item-corpo">
        <div className="trilha-item-titulo">{item.titulo}</div>
        <div className="trilha-item-sub">
          {ehDoc ? 'Aula' : 'Teste'}
          {!ehDoc && item.nota_minima ? ` • mín. ${item.nota_minima}%` : ''}
          {item.concluido && item.nota != null ? ` • nota ${item.nota}` : ''}
        </div>
      </div>
      <div className="trilha-item-status">
        {item.concluido
          ? <i className="bi bi-check-circle-fill trilha-ok"></i>
          : item.bloqueado
            ? <i className="bi bi-lock-fill trilha-lock"></i>
            : <i className="bi bi-chevron-right"></i>}
      </div>
    </>
  );

  if (item.bloqueado) {
    return <div className="trilha-item trilha-item--bloqueado" title="Conclua o item anterior pra liberar">{corpo}</div>;
  }
  return <Link to={destino} className={`trilha-item${item.concluido ? ' trilha-item--ok' : ''}`}>{corpo}</Link>;
}

export default function Trilha() {
  const { id } = useParams();
  const { temPermissao } = useAuth();
  const [data, setData] = useState(null);
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    setCarregando(true);
    api.get(`/trilhas/${id}`)
      .then(({ data }) => setData(data))
      .catch(err => setErro(err.response?.data?.error || 'Erro ao carregar trilha'))
      .finally(() => setCarregando(false));
  }, [id]);

  const t = data?.trilha;

  return (
    <>
      <Header />
      <main className="conteudo-container" style={{ maxWidth: 760 }}>
        <Link to="/academia" className="doc-voltar"><i className="bi bi-arrow-left"></i> Academia</Link>
        {carregando && <div>Carregando…</div>}
        {erro && <div className="erro">{erro}</div>}

        {t && (
          <>
            <div className="trilha-cab">
              <div className="trilha-cab-topo">
                <h1>{t.titulo}</h1>
                <div className="trilha-cab-acoes">
                  {t.publicada === false && <span className="trilha-tag-rascunho">Rascunho</span>}
                  {t.obrigatoria && <span className="trilha-tag-obrig">Obrigatória</span>}
                  {temPermissao('gerir_academia') && (
                    <Link to={`/admin/trilhas/${t.id}/editar`} className="btn-centrao-laranja" title="Editar"><i className="bi bi-pencil"></i></Link>
                  )}
                </div>
              </div>
              {t.descricao && <p className="trilha-cab-desc">{t.descricao}</p>}
              <BarraProgresso pct={data.pct} altura={10} />
              <div className="trilha-cab-pct">{data.concluidos}/{data.total} concluído{data.total === 1 ? '' : 's'} • {data.pct}%</div>
            </div>

            <div className="trilha-itens">
              {data.itens.map(it => <Item key={it.id} item={it} trilhaId={t.id} />)}
              {data.itens.length === 0 && <div className="conteudo-card" style={{ textAlign: 'center', color: 'var(--texto-suave)' }}>Esta trilha ainda não tem itens.</div>}
            </div>
          </>
        )}
      </main>
    </>
  );
}
